import { render, staticRenderFns } from "./CmgTwoStepVerificationLearnMoreModal.vue?vue&type=template&id=dd683310&scoped=true&lang=pug"
import script from "./cmg-two-step-verification-learn-more-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-two-step-verification-learn-more-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgTwoStepVerificationLearnMoreModal.vue?vue&type=style&index=0&id=dd683310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd683310",
  null
  
)

export default component.exports